import { Message } from 'element-ui'
import { CreateDownloadRangeLink, ShardDownload } from "../http/api";

/**
 * 下载get请求获取文件流分片方法
 * @param {Number} start        字节开始位置
 * @param {Number} end          字节结束位置
 * @param {Number} i            请求数
 * @param {String} FilePath     文件路径
 * @param {String} FileMD5      文件md5
 * @param {Function} progressCb 回调函数：用于获取进度
 * @returns 
 */
function downloadRange(start, end, i, FilePath, FileMD5, progressCb) {
  return new Promise((resolve, reject) => {
    let DownloadRangeUrl = `${window.BASE_API}/api/ArchivedFile/DownloadRange?filePath=${FilePath}&fileMD5=${FileMD5}`;
    let formData = new FormData();
    formData.append("startByteIndex", start);
    formData.append("endByteIndex", end);
    ShardDownload(DownloadRangeUrl, 'POST', 'blob', formData).then((_sdGet) => {
      _sdGet.data.arrayBuffer().then((buffer) => {
        progressCb();
        resolve({ i, buffer });
      });
    }).catch(err => {
      reject(err)
    })
  });
}

/**
 * 合并获取到的文件流方法
 * @param {*} resultConstructor Uint8Array
 * @param {*} arrays            Buffer
 * @returns
 */
function concatenate(resultConstructor, arrays) {
  if (!arrays.length) return null;
  let totalLength = 0;
  for (let arr of arrays) {
    totalLength += arr.length;
  }
  let result = new resultConstructor(totalLength);
  let offset = 0;
  for (let arr of arrays) {
    result.set(arr, offset);
    offset += arr.length;
  }
  return result;
}

/**
 * 文件保存
 * @param {String} fileName 文件名
 * @param {*} buffers       文件流
 * @param {*} type          文件类型
 */
function saveAs(fileName, buffers, type) {
  const blobFile = new Blob([buffers], { type });
  if (window.navigator.msSaveOrOpenBlob) {
    navigator.msSaveBlob(blobFile, fileName);
  } else {
    let a = document.createElement('a');
    a.href = URL.createObjectURL(blobFile);
    a.download = fileName;
    document.body.appendChild(a);
    a.click();
    a.remove();
  }
};

/**
 * 定义 asyncPool 函数
 * @param {Number} poolLimit    限制的并发数
 * @param {Array} array         任务数组
 * @param {Function} iteratorFn 迭代函数
 * @returns 
 */
async function asyncPool(poolLimit, array, iteratorFn) {
  const ret = [];
  const executing = [];
  for (const item of array) {
    const p = Promise.resolve().then(() => iteratorFn(item, array));
    ret.push(p);
    if (poolLimit <= array.length) {
      const e = p.then(() => executing.splice(executing.indexOf(e), 1));
      executing.push(e);
      if (executing.length >= poolLimit) {
        await Promise.race(executing);
      }
    }
  }
  return Promise.all(ret);
};

/**
 * 下载操作
 * @param {Number} size         文件总大小
 * @param {Number} chunkSize    分块的大小，单位为字节
 * @param {Number} poolLimit    限制的并发数
 * @param {String} FilePath     验证的文件路径
 * @param {String} FileMD5      验证的MD5值
 * @param {Function} progressCb 回调函数：返回进度
 * @returns 
 */
async function download({ size, chunkSize, poolLimit = 2, FilePath, FileMD5 }, progressCb) {
  const chunks = chunkSize > size ? 1 : parseInt(size / chunkSize);
  const chunkArray = [...new Array(chunks).keys()];
  let index = 0;
  const results = await asyncPool(
    poolLimit,
    chunkArray,
    (i) => {
      let start = i ? (i * chunkSize) + 1 : 1;
      let end = (i + 1 == chunks) ? size : (i + 1) * chunkSize;
      return downloadRange(start, end, i, FilePath, FileMD5, () => {
        index++;
        let progress = Math.floor((index / chunkArray.length) * 100) + "%";
        progressCb(progress);
      });
    }
  );
  const sortedBuffers = results.sort((item) => item.i - item.i).map((item) => new Uint8Array(item.buffer));
  return concatenate(Uint8Array, sortedBuffers);
};

/**
 * 下载方法
 * @param {Array} fileIds       要获取的文件ids
 * @param {Function} cb         回调
 * @param {Function} progressCb 回调函数：返回进度
 */
export default (fileIds, cb, progressCb) => {
  CreateDownloadRangeLink({ fileIds }).then((_cdrl) => {    // 创建下载链接
    var url = window.BASE_API + _cdrl;
    ShardDownload(url, 'GET').then((_sdHead) => {   // 获取文件
      if (_sdHead.data.Code != 1) {
        if (cb && typeof cb === 'function') cb();
        Message.error(_sdHead.data.Message);
        return;
      };
      var donwloadType = _sdHead.headers['content-type'] ? _sdHead.headers['content-type'] : 'application/vnd.ms-excel';
      var FileName = _sdHead.data.ZipFileInfo.FileName;
      var FilePath = _sdHead.data.ZipFileInfo.FilePath;
      var FileMD5 = _sdHead.data.ZipFileInfo.FileMD5;
      download({
        size: Number(_sdHead.data.ZipFileInfo.FileSize),
        chunkSize: 1024 * 1024 * 3,
        poolLimit: 10,
        FilePath,
        FileMD5
      }, (now) => { progressCb(now) }).then((buffers) => {
        saveAs(FileName, buffers, donwloadType);
      }).finally(() => {
        if (cb && typeof cb === 'function') cb();
      });
    }).catch((err) => {
      if (cb && typeof cb === 'function') cb();
      Message.error(err.response);
    })
  }).catch((err) => {
    if (cb && typeof cb === 'function') cb();
    Message.error(err.response);
  })
}
